module.exports = __webpack_public_path__ + "img/2.a3ee12de.jpg";